@layer components {
  .trail {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.125rem;
    inline-size: 100%;
    margin-block: calc(-1 * var(--space-1));
  }

  .crumb {
    display: inline-flex;
    align-items: center;
    gap: var(--space-2);
    min-inline-size: 0;
    min-block-size: var(--tap-target);
    padding-inline: var(--space-3);
    border: 0;
    border-radius: var(--radius-full);
    background: none;
    color: var(--color-text-muted);
    font: inherit;
    font-size: var(--text-sm);
    font-weight: 620;
    transition: background-color var(--duration-fast) var(--ease-out);

    & svg {
      flex: none;
      inline-size: 1.125rem;
      block-size: 1.125rem;
      stroke-width: 2.1;
    }

    @media (hover: hover) {
      &:hover {
        background: var(--color-surface-hover);
        color: var(--color-text);
      }
    }

    &[aria-current] {
      color: var(--color-text);
    }
  }

  .crumbChevron {
    flex: none;
    inline-size: 0.875rem;
    block-size: 0.875rem;
    color: var(--color-text-faint);
    stroke-width: 2.4;
  }

  .list {
    display: grid;
    gap: var(--space-2);
    inline-size: 100%;
    max-block-size: min(22rem, 46dvh);
    padding: var(--space-1);
    overflow-y: auto;
    overscroll-behavior: contain;
    border-radius: var(--radius-lg);
    background: var(--color-surface-sunken);
    box-shadow: var(--shadow-well);
  }

  .note {
    display: grid;
    place-items: center;
    min-block-size: 5rem;
    color: var(--color-text-muted);
    font-size: var(--text-sm);
  }

  .folders {
    display: grid;
    gap: var(--space-1);
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .folder {
    display: grid;
    grid-template-columns: auto minmax(0, 1fr) auto;
    align-items: center;
    gap: var(--space-3);
    inline-size: 100%;
    min-block-size: 3.5rem;
    padding: var(--space-2) var(--space-3) var(--space-2) var(--space-2);
    border: 0;
    border-radius: var(--radius-lg);
    background: var(--color-surface);
    color: inherit;
    font: inherit;
    text-align: start;
    box-shadow: var(--shadow-sm);
    transition:
      background-color var(--duration-fast) var(--ease-out),
      scale var(--duration-spring) var(--ease-spring);
    -webkit-tap-highlight-color: transparent;

    @media (hover: hover) {
      &:hover {
        background: var(--color-surface-hover);
      }

      &:hover [data-kind] {
        rotate: 0deg;
        scale: 1.08;
      }
    }

    &:active {
      scale: 0.98;
      transition-duration: 60ms;
    }
  }

  .folderText {
    display: grid;
    gap: 0.0625rem;
    min-inline-size: 0;
  }

  .folderName {
    overflow: hidden;
    font-size: var(--text-base);
    font-weight: 620;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .folderCount {
    color: var(--color-text-muted);
    font-size: var(--text-sm);
    font-variant-numeric: tabular-nums;
  }

  .folderChevron {
    flex: none;
    color: var(--color-text-faint);
  }

  .more {
    justify-self: center;
  }
}
